export default "__VITE_ASSET__Dp$2Ynz2__"